import React from "react";
import { useSector } from "./SectorContext";
import { useNavigate } from "react-router-dom";

function FooterSection() {
  const { activeSector, changeSector } = useSector();
  const navigate = useNavigate();

  return (
    <section className="footer-section">
      <div className="footer-container">
        <p className={`footer-banner ${activeSector.colorClass}`}>
          LETS DO IT!
        </p>

        <div className="footer-nav">
          <ul className="footer-sector-nav">
            <li
              className="footer-sector-item underline-first"
              onClick={() => changeSector("cyber")}
            >
              Cyber
            </li>

            <li
              className="footer-sector-item underline-first"
              onClick={() => changeSector("advertising")}
            >
              Advertising
            </li>

            {/* <li
              className="footer-sector-item underline-first"
              onClick={() => changeSector("web")}
            >
              Web
            </li> */}
          </ul>
          <ul className="footer-menu">
            <li
              className="footer-item, underline-first"
              onClick={() => navigate("/")}
            >
              Home
            </li>
            <li
              className="footer-item, underline-first"
              onClick={() => navigate("/about")}
            >
              About
            </li>
            <li
              className="footer-item, underline-first"
              onClick={() => navigate("/contact")}
            >
              Contact
            </li>
          </ul>{" "}
          <ul className="footer-sector-nav social-links">
            <li className="footer-sector-item underline-first">
              <a
                href="https://www.linkedin.com/in/valentino-lloyd"
                target="_blank"
                rel="noopener noreferrer"
              >
                LinkedIn
              </a>
            </li>

            {/* <li className="footer-sector-item underline-first">
              <a
                href="https://facebook.com/yourprofile"
                target="_blank"
                rel="noopener noreferrer"
              >
                Facebook
              </a>
            </li>

            <li className="footer-sector-item underline-first">
              <a
                href="https://instagram.com/yourprofile"
                target="_blank"
                rel="noopener noreferrer"
              >
                Instagram
              </a>
            </li> */}
          </ul>
        </div>
        <p className="footer-copyright">© 2026 </p>
      </div>
    </section>
  );
}

export default FooterSection;
